import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Transaction } from 'src/model/transaction.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { TransactionService } from 'src/services/transaction.service';

@Component({
    selector: 'app-manage-transaction-subtype',
    templateUrl: './manage-transaction-subtype.component.html',
    styleUrls: ['./manage-transaction-subtype.component.scss'],
    standalone: false
})
export class  ManageTransactionSubtypeComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private transactionService = inject(TransactionService);

  @Input() subtypeList: TransactionSubType[] = [];
  @Input() currentSubtype: number;
  @Input() transaction: Transaction;

  @Output() passEntry = new EventEmitter<any>();

  disabledSubmit = false;

  ngOnInit(): void { }

  async submit() {
    const t = await this.transactionService.patchSetTransactionSubtype(this.transaction.ID, Number(this.currentSubtype));
    this.passEntry.emit(t);
    this.closeModal();
  }

  closeModal() {
    this.activeModal.close();
  }
}
